import type { FC } from 'react'

import type { ModalSimulationRightMenuProps } from './types'
import { GeometryMenu, LayersMenu, ModelMenu } from './VelocitySimulationRightMenu'

export const ModalSimulationRightMenu: FC<ModalSimulationRightMenuProps> = ({
  activeStep,
  choiceValue,
  setChoiceValue,
  formData,
  setFormData,
  modelResults,
  existingModelsList,
  chosenVelocityModel,
  onChangeVelocityModel,
  addedSelectItemList,
  updateSelectItemList,
  calculationStatus,
}) => {
  switch (activeStep) {
    case 'model':
      return (
        <ModelMenu
          existingModelsList={existingModelsList}
          chosenVelocityModel={chosenVelocityModel}
          choiceValue={choiceValue}
          setChoiceValue={setChoiceValue}
          modelName={formData.model.name}
          setFormData={setFormData}
          onChangeVelocityModel={onChangeVelocityModel}
        />
      )
    case 'layers':
      return (
        <LayersMenu
          choiceValue={choiceValue}
          setChoiceValue={setChoiceValue}
          addedSelectItemList={addedSelectItemList}
          updateSelectItemList={updateSelectItemList}
          formData={formData}
          setFormData={setFormData}
          modelResults={modelResults?.layers}
          calculationStatus={calculationStatus}
        />
      )
    case 'geometry':
      return (
        <GeometryMenu
          chosenVelocityModel={chosenVelocityModel}
          modelResults={modelResults?.geometry}
        />
      )
    default:
      return null
  }
}
